import nav from "../constants/nav";

const NavigationDots = ({ active }) => (
  <div className="app__navigation">
    {nav.map((item, index) => (
      <a
        href={`#${item?.value}`}
        key={item?.value + index}
        className="app__navigation-dot"
        style={active === item?.value ? { backgroundColor: "#e53a34" } : {}}
      />
    ))}
  </div>
);

export default NavigationDots;
